import {axios} from '@/utils/request'

const api = {
    zuofei: '/adminapi/fapiao/zuofei',
    fapiaoDelete: '/adminapi/fapiao/fapiaoDelete',
    refreshFapiao: '/adminapi/fapiao/refreshFapiao',
    kaipiao: '/adminapi/fapiao/kaipiao',
}

export default api

export function fapiaoZuofei(parameter) {
    return axios({
        url: api.zuofei,
        method: 'get',
        params: parameter
    })
}

export function fapiaoDelete(parameter) {
    return axios({
        url: api.fapiaoDelete,
        method: 'get',
        params: parameter
    })
}


export function refreshFapiao(parameter) {
    return axios({
        url: api.refreshFapiao,
        method: 'get',
        params: parameter
    })
}

export function kaipiao(parameter) {
    return axios({
        url: api.kaipiao,
        method: 'get',
        params: parameter
    })
}

 